import { RESET_STATE } from '../auth/constants';
import { TIMESHEET_ENTRIES_SET } from './constants';

const initialState = {};

type State = {};

export default function (state: State = initialState, action: any): State {
    switch (action.type) {
        case TIMESHEET_ENTRIES_SET:
            return action.payload;
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
